import React from "react";
import { useI18n } from "../i18n";

export default function LegalPage({ contentKey, testId }) {
  const { dict } = useI18n();
  const data = dict[contentKey];

  return (
    <main
      className="bg-white border-b border-gray-200"
      data-testid={testId || `legal-${contentKey}`}
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-8 py-16 md:py-24">
        <p className="text-xs uppercase tracking-widest font-bold text-[#1E3A8A]">
          {data.updated}
        </p>
        <h1 className="mt-4 font-serif font-medium text-4xl md:text-5xl text-[#101828] tracking-tight leading-[1.05]">
          {data.title}
        </h1>
        <div className="mt-10 space-y-8">
          {data.sections.map((section, i) => (
            <section
              key={i}
              className="border-t border-gray-200 pt-6"
              data-testid={`${contentKey}-section-${i}`}
            >
              <h2 className="font-serif text-2xl text-[#101828] tracking-tight">
                {section.heading}
              </h2>
              <p className="mt-3 text-base text-[#475467] leading-relaxed">
                {section.body}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
